<div>
  @switch (condition) {
    @case (true) {
      <mat-icon class="green">task_alt</mat-icon>
    }
    @case (false) {
      <mat-icon class="warn">clear</mat-icon>
    }
  }
</div>
